import { Injectable } from '@angular/core';
import { ValidationResult } from '../models/validation-result.model';

@Injectable({
    providedIn: 'root'
})
export class PhoneValidatorService {

    public phoneRegexPattern  : RegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,5}$/;
    private formatErrorMessage: string = 'El formato del teléfono es incorrecto';

    constructor() { }

    public validate(phone: string) : ValidationResult  {

        let result = new ValidationResult();

        // Converts to lowercase.
        phone = phone?.toLowerCase();

        // Checks format.
        if (!this.phoneRegexPattern.test(phone)) {

            result.setInvalidResult(this.formatErrorMessage);
            return result;

        }

        result.setValidResult();
        return result;


    }

}
